import React, { Component } from 'react';
import T from 'prop-types';
// utils
import moment from 'moment';
// components
import Week from './components/Week';
import Events from './components/Events';
import DayNames from './components/DayNames';
import Icon from '../Icon/Icon';
// styles
import Color from 'color';
import Style from 'style-it';
import styles from './Calendar.mod.css';
import classnames from 'classnames/bind';

const cx = classnames.bind(styles);

class Calendar extends Component {
  state = {
    selectedMonth: moment(),
    selectedDay: moment().startOf('day'),
    showEvents: false,
  };

  previous = () => {
    const { selectedMonth } = this.state;
    this.setState({
      selectedMonth: selectedMonth.subtract(1, 'month'),
    });
  };

  next = () => {
    const { selectedMonth } = this.state;
    this.setState({
      selectedMonth: selectedMonth.add(1, 'month'),
    });
  };

  select = day => {
    this.setState({
      selectedMonth: day.date,
      selectedDay: day.date.clone(),
      showEvents: true,
    });
  };

  goToCurrentMonthView = () =>
    this.setState({
      selectedMonth: moment(),
    });

  showCalendar = () =>
    this.setState({
      showEvents: false,
    });

  renderDayLabel = () => {
    const { selectedDay } = this.state;
    return (
      <span className={cx('month-label')}>
        {selectedDay.format('DD MMMM YYYY')}
      </span>
    );
  };

  renderWeeks = () => {
    const { selectedMonth, selectedDay } = this.state;
    const { color, events, recoveryStats, isDailyCheckIn } = this.props;
    const weeks = [];
    let done = false;

    let previousCurrentNextView = selectedMonth
      .clone()
      .startOf('month')
      .subtract(1, 'd')
      .day('Monday');

    let count = 0;
    let monthIndex = previousCurrentNextView.month();

    while (!done) {
      weeks.push(
        <Week
          key={count}
          color={color}
          previousCurrentNextView={previousCurrentNextView.clone()}
          currentMonthView={selectedMonth}
          events={events}
          selected={selectedDay}
          select={day => this.select(day)}
          recoveryStats={recoveryStats}
          isDailyCheckIn={isDailyCheckIn}
        />
      );
      previousCurrentNextView.add(1, 'w');
      done = count++ > 2 && monthIndex !== previousCurrentNextView.month();
      monthIndex = previousCurrentNextView.month();
    }
    return weeks;
  };

  render() {
    const { showEvents, selectedMonth, selectedDay } = this.state;
    const { color, events, isDailyCheckIn, className = '' } = this.props;
    const weeks = this.renderWeeks();
    const monthLabel = selectedMonth.format('MMMM YYYY');

    return showEvents && !isDailyCheckIn ? (
      <section className={cx('main-calendar', 'events', className)}>
        <header className={cx('calendar-header')}>
          <Style>
            {`button:hover { background-color: ${Color(color).lighten(0.1)}`}
            <div
              className={cx('title-header')}
              style={{ backgroundColor: color }}
            >
              <button
                aria-label="prev"
                className={cx('button', 'nav-button')}
                onClick={this.showCalendar}
              >
                <Icon type="chevron-up" className={cx('icon', 'icon-prev')} />
              </button>
              {this.renderDayLabel()}
            </div>
          </Style>
        </header>
        <Events
          color={color}
          showCalendar={this.showCalendar}
          selectedMonth={selectedMonth}
          selectedDay={selectedDay}
          events={events}
        />
      </section>
    ) : (
      <section className={cx('main-calendar', className)}>
        <header className={cx('calendar-header')}>
          <Style>
            {`button:hover { background-color: ${Color(color).lighten(0.1)}`}
            <div
              className={cx('title-header')}
              style={{ backgroundColor: color }}
            >
              <button
                aria-label="previous"
                className={cx('button', 'nav-button')}
                onClick={this.previous}
              >
                <Icon type="chevron-up" className={cx('icon', 'icon-prev')} />
              </button>
              <div className={cx('header-text')}>
                <button
                  aria-label="today"
                  className={cx('button', 'today-label')}
                  onClick={this.goToCurrentMonthView}
                >
                  Today
                </button>
                <span className={cx('month-label')}>{monthLabel}</span>
              </div>
              <button
                aria-label="next"
                className={cx('button', 'nav-button')}
                onClick={this.next}
              >
                <Icon type="chevron-up" className={cx('icon', 'icon-next')} />
              </button>
            </div>
          </Style>
          <DayNames color={color} />
        </header>
        <div className={cx('days-container', 'fadeIn')}>{weeks}</div>
      </section>
    );
  }
}

Calendar.propTypes = {
  color: T.string.isRequired,
  className: T.string,
  recoveryStats: T.object,
  isDailyCheckIn: T.bool,
  events: T.arrayOf(
    T.shape({
      id: T.number.isRequired,
      skill_dates: T.arrayOf(
        T.shape({
          id: T.number.isRequired,
          multiplicator: T.number,
          period: T.oneOf(['day', 'week', 'month', 'year']),
          start_date: T.string,
          stop_date: T.string,
        })
      ),
    })
  ),
};

export default Calendar;



// WEBPACK FOOTER //
// ./src/components/Calendar/Calendar.jsx